import { authUrlPre, userUrlPre, smsImgUrl } from 'comm/src/config'
import { reqService } from 'comm/src/plugins/request'
const loginUrl = authUrlPre + '/oauth/token'
const changePasswordUrl = authUrlPre + '/user/resetPassword'
const getPermissionUrl = authUrlPre + '/menus/current'
const getUserInfosUrl = authUrlPre + '/user/current'
const tenantInfo = authUrlPre + '/tenant/current' // 租户信息
const userInfoUrl = authUrlPre + '/user/getUserInfo' // 获取用户信息
const accountInfoUrl = authUrlPre + '/user/info' // 获取账户信息
const passPortSsoUrl = authUrlPre + '/passport-sso' // 统一平台单点登录
const sourcePassPortUrl = authUrlPre + '/passport-sso' // 统一平台单点登录(多系统)
const waterJumpUrl = authUrlPre + '/common/getDrinkAddress' // 统一平台单点登录


const noiseRegister = '/api/uaa/tenantRegisterAudit/register' // 统一平台单点登录
// 登录
export const login = async data => {
  const res = await reqService({
    method: 'POST',
    url: loginUrl,
    params: data
  })
  return res
}

// 用户自己修改密码
export const changePassword = async data => {
  const res = await reqService({
    method: 'PUT',
    url: changePasswordUrl,
    params: data
  })
  return res
}

// 获取用户权限
export const getPermission = data => {
  return reqService({
    method: 'GET',
    url: getPermissionUrl,
    params: data
  })
}
// 获取验证码
export const getVisible = () => {
  return reqService({
    method: 'GET',
    url: smsImgUrl
  })
}
export const getUserInfos = () => {
  return reqService({
    method: 'GET',
    url: getUserInfosUrl
  })
}

// 获取租户信息
export const getTenantInfos = async () => {
  return await reqService({
    method: 'GET',
    url: tenantInfo
  })
}

export const getUserAllInfo = async params => {
  return await reqService({
    method: 'GET',
    url: userInfoUrl,
    params
  })
}
// 获取账户相关信息
export const getAccountInfos = data => {
  return reqService({
    method: 'GET',
    url: accountInfoUrl,
    params: data
  })
}
// 统一平台单点登录
export const passportSso = data => {
  return reqService({
    method: 'POST',
    url: passPortSsoUrl,
    data
  })
}
// 统一平台单点登录(多系统)
export const sourcePassPort = data => {
  return reqService({
    method: 'POST',
    url: sourcePassPortUrl,
    data
  })
}

// 获取直饮水跳转地址
export const getWaterJumpUrl = async data => {
  return await reqService({
    method: 'GET',
    url: waterJumpUrl,
    params: data
  })
}

// 获取直饮水跳转地址
export const getNoiseRegister = async data => {
  return await reqService({
    method: 'POST',
    url: noiseRegister,
    data: data
  })
}